import styled from 'styled-components'

export const CatalogItemActionsStyled = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  /* The policy-badge column collapses when a card has no badges, so the
     actions anchor themselves to the trailing edge instead of relying on it. */
  margin-left: auto;
  gap: ${(props) => props.theme.space.medium};
`
